import styled, { css } from 'styled-components/macro';
import { rgba } from 'polished';
import modularScale from 'styles/helpers/modular-scale';
import { numbersTypography } from 'styles/global/typography/typography';

export const definitionLabel = ({ theme }: { theme: any }): any => css`
  font-size: ${modularScale(-2)};
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: ${theme.CasperGrey};
  line-height: 1.2;
`;

export const DefinitionLabel = styled.p`
  ${definitionLabel};
`;

export const definitionValue = css`
  ${numbersTypography};
  font-weight: 600;
  line-height: 1.2;
`;

export const helperText = ({ theme }: { theme: any }): any => css`
  text-align: center;
  font-size: ${modularScale(-1)};
  color: ${theme.CasperGrey};
`;

export const boxShadow = ({ theme }: { theme: any }): any => css`
  box-shadow: 0 -1px 1px 0 ${rgba(theme.ShadowBlack, 0.05)},
    0 1px 1px 0 ${rgba(theme.ShadowBlack, 0.1)},
    0 2px 2px 0 ${rgba(theme.ShadowBlack, 0.075)},
    0 4px 4px 0 ${rgba(theme.ShadowBlack, 0.05)},
    0 8px 8px 0 ${rgba(theme.ShadowBlack, 0.05)};
`;

export const topBarButton = ({
  theme,
  withoutOnHover,
}: {
  theme: any;
  withoutOnHover?: boolean;
}): any => css`
  height: ${theme.topbarHeight};
  min-width: ${theme.topbarHeight};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-weight: 600;
  background: rgba(0, 0, 0, 0);
  color: ${theme.NightBlue};
  transition: ${`
  ${theme.transitionDuration} ${theme.timingFunction} background,
  ${theme.transitionDuration} ${theme.timingFunction} opacity`};
  white-space: nowrap;

  ${!withoutOnHover &&
  `
    &:hover,
    &:focus {
      background: rgba(0, 0, 0, 0.08);
    }
    &:focus {
      outline-color: ${theme.NightBlue};
    }
    &:active {
      background: rgba(0, 0, 0, 0.1);
    }
  `}

  :disabled {
    opacity: 0.5;
    &:hover {
      background: inherit;
      cursor: not-allowed;
    }
  }

  span {
    display: none;
  }

  svg {
    flex-shrink: 0;
  }

  @media screen and (min-width: 44rem) {
    padding: 0 1em;
    span {
      display: inline;
    }
  }
`;

export const defaultButton = ({ theme }: { theme: any }): any => css`
  appearance: none;
  background: ${theme.Sand};
  padding: ${`${theme.spacing.xsmall} ${theme.spacing.medium}`};
  font-weight: 600;
  color: ${theme.NightBlue};
  transition: ${`all ${theme.transitionDuration} ${theme.timingFunction}`};

  &:hover {
    background: ${theme.LightGrey};
  }

  &:focus,
  &:active {
    background: ${theme.Grey};
  }
`;

export const showMoreButton = ({ theme }: { theme: any }): any => css`
  appearance: none;
  width: 100%;
  font-weight: 600;
  text-align: left;
  color: ${theme.AccentGreen};
  padding: ${theme.spacing.small};
  padding-left: ${theme.spacing.huge};
  margin: 0;

  &:hover,
  &:focus {
    background: ${theme.Sand};
  }
  &:active {
    background: ${theme.LightGrey};
  }
`;

export const linkStyling = ({ theme }: { theme: any }): any => css`
  text-decoration: none;
  color: inherit;
  position: relative;
  padding-bottom: 2px;
  box-shadow: 0px 1px 0px 0px ${theme.AccentGreen};
  transition: ${`${theme.transitionDuration} ${theme.timingFunction} color`};

  &:focus,
  &:active {
    background: ${theme.Sand};
    color: ${theme.AccentGreen};
  }

  &:hover {
    box-shadow: 0px 2px 0px 0px ${theme.AccentGreen};
  }
`;

export const scrollBar = ({ theme }: { theme: any }): any => css`
  /* Customize the scroll thumb */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    width: 6px;
    border-radius: 3.5px;
    background-color: ${theme.LightGrey};
  }
  scrollbar-color: ${theme.LightGrey} ${theme.White};
  scrollbar-width: thin;
`;
